import { CSSObject } from "@emotion/react";
import { ToggleButton } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import {
  gradientBorderCircleCss,
  gradientBorderTrackCss,
  partialCtaDefaultLinearGradientBackground,
  partialCtaDefaultLinearGradientLightBackground,
} from "../AiComponents.style";

interface AIToggleProps {
  pressed: boolean;
  onToggle: () => void;
  ariaLabel?: string;
  labelText?: string;
  qaSelector?: string;
  description?: string;
  showGradientBorder?: boolean;
  disabled?: boolean;
}

const ToggleWithTrackEvent = withTrackEvent(ToggleButton);

const AIToggle = ({
  pressed,
  onToggle,
  ariaLabel = "Search with Luna",
  labelText = "Search with Luna",
  qaSelector = "search-with-luna-toggle",
  description = "Toggle Search with Luna",
  showGradientBorder = false,
  disabled = false,
}: AIToggleProps) => {
  const defaultSwitchContainerCss: CSSObject = {
    ...partialCtaDefaultLinearGradientBackground,
  };

  return (
    <ToggleWithTrackEvent
      ariaProps={{
        "aria-label": ariaLabel,
        "aria-pressed": pressed,
      }}
      label={labelText}
      __cssFor={{
        switchContainerStyles: {
          ...(pressed
            ? defaultSwitchContainerCss
            : showGradientBorder
              ? partialCtaDefaultLinearGradientLightBackground
              : undefined),
          ...(showGradientBorder && gradientBorderTrackCss(pressed)),
        },
        ...(showGradientBorder && { Icon: { root: gradientBorderCircleCss } }),
      }}
      dataProps={{
        "data-qa-selector": qaSelector,
        "data-state": pressed ? "on" : "off",
      }}
      objectType={objectTypes.user}
      actionName={actionNames.interact}
      streamProperties={{
        description,
      }}
      pressed={pressed}
      onClick={onToggle}
      disabled={disabled}
    />
  );
};

AIToggle.displayName = "AIToggle";

export default AIToggle;
